export default "__VITE_ASSET__CQjCh9aN__"